module.exports = __webpack_public_path__ + "img/ComplianceTable.314912f9.png";